const { initTermTimelineTabs } = require('./term-timeline-tabs');

function init(scope = document) {
    initTermTimelineTabs(scope);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
} else {
    init(document);
}

window.eckoTermTimeline = window.eckoTermTimeline || {};
window.eckoTermTimeline.initTabs = init;
